module.exports = __webpack_public_path__ + "img/empty-organization.b7f6e048.svg";